export default __webpack_public_path__ + "static/media/logo.396e619f.png";